export class NameAndIdentifier {
    systemName: string;
    systemNameAbbreviation: string;
    type: number;
    description: string;
}
